import { MainViewMode } from '@app/core/enums/main-view-mode.enum';

export const mainData = 'mainData';

export interface IMainDataRequestState {
  viewMode?: MainViewMode;
  projectId?: string;
  areaId?: string;
  date?: string;
}

export interface IMainDataState {
  loaded: boolean;
  loading: boolean;
  triggerId: string | null;
  request: IMainDataRequestState | null;
}

export const initialMainDataState: IMainDataState = {
  loaded: false,
  loading: false,
  triggerId: null,
  request: null,
};
